import { c as n, b as t } from "../../../polished.esm-CcKPP1J6.js";
import l from "../shared/current/colors.mjs";
const { global: r } = l, e = {
  light: r.white,
  dark: r.black
}, o = {
  light: r.white,
  dark: r.black
}, i = {
  default: r.black
}, d = {
  focus: {
    borderDark: r.grey500,
    borderLight: r.white
  },
  checkbox: {
    checkedColor: r.grey300,
    uncheckedColor: r.white,
    borderColor: r.grey500,
    errorColor: r.black
  },
  input: {
    text: {
      default: r.black,
      placeholder: r.grey500,
      divider: r.grey300
    },
    border: {
      default: r.grey500,
      success: r.black,
      error: r.black,
      alert: r.black,
      focus: r.grey500
    },
    unified: {
      border: {
        default: r.grey500,
        success: r.black,
        error: r.black,
        alert: r.black,
        focus: r.grey500
      }
    }
  },
  fieldset: {
    border: r.grey100
  }
}, c = {
  dark: r.grey500,
  darkHover: r.grey600,
  darkIcon: "currentColor",
  darkIconHover: "currentColor",
  light: r.white,
  lightHover: r.grey100,
  lightIcon: "currentColor",
  lightIconHover: "currentColor"
}, a = {
  default: r.black,
  dark: r.black,
  light: r.white
}, k = {
  itemWrapper: e.light,
  wrapper: {
    light: e.light,
    mid: r.grey200,
    dark: r.grey50
  }
}, g = {
  alertIcon: {
    primary: r.grey200,
    secondary: r.black
  },
  bankIcon: {
    primary: r.grey200
  },
  bellIcon: {
    primary: r.grey200
  },
  clipboardIcon: {
    primary: r.grey200,
    secondary: r.black
  },
  eyeIcon: {
    primary: r.grey200
  },
  gearsIcon: {
    primary: r.grey200,
    secondary: r.black
  },
  heartIcon: {
    primary: r.grey200
  },
  lightningIcon: {
    primary: r.grey200
  },
  mailIcon: {
    primary: r.grey200,
    secondary: r.black
  },
  nopeIcon: {
    primary: r.grey200,
    secondary: r.black
  },
  padlockIcon: {
    primary: r.grey200
  },
  paymentIcon: {
    primary: r.grey200,
    secondary: r.black
  },
  pinIcon: {
    primary: r.grey200,
    secondary: r.black
  },
  planeIcon: {
    primary: r.grey200
  },
  stopwatchIcon: {
    primary: r.grey200,
    secondary: r.black
  },
  switchesIcon: {
    primary: r.grey200,
    secondary: r.black
  },
  thumbsUpIcon: {
    primary: r.grey200
  },
  tickIcon: {
    primary: r.grey200,
    secondary: r.black
  }
}, b = {
  backgroundColor: e.dark,
  color: a.light
}, h = {
  iconColor: "currentColor",
  iconColorHover: "currentColor"
}, s = {
  action: {
    text: a.default,
    background: e.light,
    border: o.dark,
    hoverBackground: e.light,
    hoverBorder: o.dark
  },
  confirmation: {
    text: a.default,
    background: e.light,
    border: o.dark,
    hoverBackground: e.light,
    hoverBorder: o.dark
  },
  decision: {
    text: a.default,
    background: e.light,
    border: o.dark,
    hoverBackground: e.light,
    hoverBorder: o.dark
  },
  destructive: {
    text: a.default,
    background: e.light,
    border: o.dark,
    hoverBackground: e.light,
    hoverBorder: o.dark
  },
  secondary: {
    text: a.default,
    background: e.light,
    border: o.dark,
    hoverBackground: e.light,
    hoverBorder: o.dark
  },
  textLink: {
    text: c.dark,
    background: r.transparent,
    border: r.transparent,
    hoverText: n(0.2, c.dark),
    icon: r.black
  },
  secondaryLink: {
    text: c.light,
    background: r.transparent,
    border: r.transparent,
    hoverText: c.light
  }
}, y = {
  backgroundLight: e.light,
  backgroundDark: e.dark
}, u = {
  primary: e.dark
}, p = {
  background: e.dark,
  headingText: r.white,
  borderColor: r.white
}, w = {
  informationBackgroundColor: r.grey50
}, m = {
  border: o.light
}, f = {
  border: r.grey300,
  button: r.grey200,
  buttonHover: r.black
}, v = {
  default: {
    background: r.grey100,
    surface: r.white
  },
  variant1: {
    background: r.white,
    surface: r.grey100
  },
  variant2: {
    background: r.grey100,
    surface: r.white
  },
  icon: r.black,
  heading: {
    default: r.black,
    variant1: r.black,
    variant2: r.black
  },
  text: {
    default: r.black,
    variant1: r.black,
    variant2: r.black
  }
}, x = {
  default: {
    background: r.white,
    surface: r.grey100
  },
  variant1: {
    background: r.grey100,
    surface: r.white
  },
  variant2: {
    background: r.white,
    surface: r.grey100
  }
}, B = {
  light: {
    background: r.grey50,
    link: {
      color: r.white,
      hover: r.white
    }
  },
  lightSecondary: {
    background: r.white,
    link: {
      color: r.white,
      hover: r.white
    }
  },
  dark: {
    background: r.black,
    link: {
      color: r.black,
      hover: r.grey300
    }
  }
}, I = {
  background: r.grey50,
  headingText: r.black,
  borderColor: r.grey500
}, C = {
  dark: r.grey50,
  light: r.white,
  imageBg: r.grey200,
  icon: r.grey200
}, T = {
  background: {
    mobile: r.white,
    desktop: r.black
  },
  border: {
    mobile: r.black,
    desktop: r.white
  }
}, S = {
  default: r.grey500,
  success: r.black,
  error: r.black,
  alert: r.grey300
}, H = {
  heading: r.black,
  icon: r.black,
  panel: {
    dark: r.grey50
  }
}, L = {
  variants: {
    info: r.black,
    success: r.black,
    alert: r.black,
    error: r.black
  },
  background: r.grey50
}, D = {
  dark: r.black,
  light: r.white
}, P = {
  dark: r.black,
  light: r.white
}, q = {
  icon: r.white
}, z = {
  bgSolid: e.light,
  bgTranslucentBlur: t(0.3, e.light),
  bgTranslucentNoBlur: t(0.1, e.light),
  circle: r.black
}, A = {
  background: r.white,
  icon: r.black,
  divider: r.grey50,
  closeButton: r.black
}, F = {
  panel: {
    background: r.white,
    border: r.grey100
  }
}, U = {
  step: {
    filled: r.black,
    remaining: r.white,
    dark: {
      text: r.black
    },
    light: {
      text: r.white
    }
  },
  marker: {
    icon: r.black,
    accent: r.white
  },
  base: {
    border: r.black
  }
}, $ = {
  radioError: r.black,
  containerBorder: r.grey50,
  checked: r.black,
  radioButtonBorder: r.grey500,
  radioButtonBackground: r.white,
  squareRadioButtonBorder: r.grey500,
  squareChecked: r.black,
  squareUncheckedText: r.black,
  squareCheckedText: r.white
}, E = {
  input: {
    dark: {
      border: r.grey500,
      borderFocus: r.black,
      searchIcon: r.black,
      clearIcon: r.black,
      text: r.black,
      placeholder: r.grey500
    },
    light: {
      border: r.white,
      borderFocus: r.grey500,
      searchIcon: r.black,
      clearIcon: r.white,
      text: r.white,
      placeholder: r.grey50
    }
  },
  results: {
    border: r.grey50,
    wrapper: r.white
  }
}, G = {
  text: r.black,
  box: r.black,
  border: r.grey200,
  background: r.white
}, M = {
  head: {
    background: r.grey50
  },
  foot: {
    background: r.grey50
  },
  row: {
    border: r.grey100
  }
}, N = {
  tabList: {
    background: {
      dark: r.white,
      light: r.grey600
    },
    border: {
      dark: r.black,
      light: r.transparent
    }
  },
  tab: {
    borderActive: {
      dark: r.black,
      light: r.black
    },
    text: {
      dark: r.black,
      light: r.white
    },
    hoverText: {
      dark: r.black,
      light: r.white
    }
  }
}, R = {
  cross: r.black
}, W = {
  checked: r.black,
  unchecked: r.grey50,
  border: r.grey500,
  error: r.black,
  checkedDot: r.white,
  uncheckedDot: r.grey500,
  checkedText: r.white,
  uncheckedText: r.grey600
}, j = {
  text: {
    error: r.black,
    normal: r.black
  },
  base: r.grey200,
  slider: {
    error: r.black,
    normal: r.black
  }
}, O = {
  accordion: k,
  animatedIcon: g,
  background: e,
  badge: b,
  backButton: h,
  border: o,
  button: s,
  card: y,
  celebration: u,
  cookieBanner: p,
  cookieModal: w,
  curve: m,
  errorSummary: f,
  flow: v,
  flowPoint: x,
  footer: B,
  forms: d,
  fullPageCookieBanner: I,
  getApp: C,
  header: T,
  heading: i,
  helperText: S,
  iconSummaryPanel: H,
  infoPanel: L,
  label: D,
  legend: P,
  link: c,
  list: q,
  loadingSpinner: z,
  modal: A,
  multiPanelSection: F,
  progressBar: U,
  radioGroup: $,
  search: E,
  skipLink: G,
  table: M,
  tabs: N,
  text: a,
  toastBanner: R,
  toggleSwitch: W,
  totalizer: j
};
export {
  O as default
};
